import { MessageCircle } from 'lucide-react';

export default function WhatsAppFloat() {
  return (
    <a
      href="https://wa.me/18299838580?text=Hola%20Ferr%20Tours%2C%20me%20gustar%C3%ADa%20informaci%C3%B3n%20sobre%20transporte"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform hover:shadow-[0_0_20px_rgba(37,211,102,0.5)]"
      data-testid="whatsapp-float-btn"
      aria-label="Chat on WhatsApp"
    >
      <svg viewBox="0 0 32 32" className="w-8 h-8 fill-white">
        <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16c0 3.5 1.128 6.744 3.046 9.378L1.054 31.29l6.118-1.958C9.72 31.058 12.738 32 16.004 32 24.826 32 32 24.822 32 16S24.826 0 16.004 0zm9.335 22.594c-.39 1.1-1.932 2.014-3.182 2.28-.856.182-1.974.326-5.738-1.234-4.818-1.994-7.92-6.878-8.162-7.196-.232-.318-1.952-2.6-1.952-4.958s1.234-3.516 1.672-3.996c.39-.428 1.028-.624 1.64-.624.198 0 .376.01.536.018.438.018.658.044.948.734.362.862 1.246 3.042 1.354 3.264.11.222.184.48.036.77-.138.3-.208.486-.414.748-.208.264-.436.588-.624.79-.208.24-.424.498-.182.976.242.478 1.078 1.778 2.314 2.88 1.59 1.416 2.93 1.854 3.348 2.06.418.208.662.174.906-.104.252-.286 1.078-1.254 1.366-1.684.28-.43.566-.356.952-.214.39.144 2.466 1.164 2.89 1.376.422.214.704.318.808.498.102.178.102 1.04-.288 2.14z"/>
      </svg>
    </a>
  );
}
